// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! locomotive-scroll v4.1.3 | MIT License | https://github.com/locomotivemtl/locomotive-scroll */
html.has-scroll-smooth {
    overflow: hidden; }
  
  html.has-scroll-dragging {
    -webkit-user-select: none;
    user-select: none; }
  
  .has-scroll-smooth body {
    overflow: hidden; }
  
  .has-scroll-smooth [data-scroll-container] {
    min-height: 100vh; }
  
  [data-scroll-direction="horizontal"] [data-scroll-container] {
    height: 100vh;
    display: inline-block;
    white-space: nowrap; }
  
  [data-scroll-direction="horizontal"] [data-scroll-section] {
    display: inline-block;
    vertical-align: top;
    white-space: nowrap;
    height: 100%; }
  
  .c-scrollbar {
    position: absolute;
    right: 0;
    top: 0;
    width: 11px;
    height: 100%;
    transform-origin: center right;
    transition: transform 0.3s, opacity 0.3s;
    opacity: 0; }
    .c-scrollbar:hover {
      transform: scaleX(1.45); }
    .c-scrollbar:hover, .has-scroll-scrolling .c-scrollbar, .has-scroll-dragging .c-scrollbar {
      opacity: 1; }
    [data-scroll-direction="horizontal"] .c-scrollbar {
      width: 100%;
      height: 10px;
      top: auto;
      bottom: 0;
      transform: scaleY(1); }
      [data-scroll-direction="horizontal"] .c-scrollbar:hover {
        transform: scaleY(1.3); }
  
  .c-scrollbar_thumb {
    position: absolute;
    top: 0;
    right: 0;
    background-color: black;
    opacity: 0.5;
    width: 7px;
    border-radius: 10px;
    margin: 2px;
    cursor: grab; }
    .has-scroll-dragging .c-scrollbar_thumb {
      cursor: grabbing; }
    [data-scroll-direction="horizontal"] .c-scrollbar_thumb {
      right: auto;
      bottom: 0; }`, "",{"version":3,"sources":["webpack://./src/assets/css/locomotive-scroll.css"],"names":[],"mappings":"AAAA,iGAAiG;AACjG;IACI,gBAAgB,EAAE;;EAEpB;IACE,yBAAyB;IAGzB,iBAAiB,EAAE;;EAErB;IACE,gBAAgB,EAAE;;EAEpB;IACE,iBAAiB,EAAE;;EAErB;IACE,aAAa;IACb,qBAAqB;IACrB,mBAAmB,EAAE;;EAEvB;IACE,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY,EAAE;;EAEhB;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,wCAAwC;IACxC,UAAU,EAAE;IACZ;MACE,uBAAuB,EAAE;IAC3B;MACE,UAAU,EAAE;IACd;MACE,WAAW;MACX,YAAY;MACZ,SAAS;MACT,SAAS;MACT,oBAAoB,EAAE;MACtB;QACE,sBAAsB,EAAE;;EAE9B;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,WAAW;IAEX,YAAY,EAAE;IACd;MAEE,gBAAgB,EAAE;IACpB;MACE,WAAW;MACX,SAAS,EAAE","sourcesContent":["/*! locomotive-scroll v4.1.3 | MIT License | https://github.com/locomotivemtl/locomotive-scroll */\nhtml.has-scroll-smooth {\n    overflow: hidden; }\n  \n  html.has-scroll-dragging {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n  \n  .has-scroll-smooth body {\n    overflow: hidden; }\n  \n  .has-scroll-smooth [data-scroll-container] {\n    min-height: 100vh; }\n  \n  [data-scroll-direction=\"horizontal\"] [data-scroll-container] {\n    height: 100vh;\n    display: inline-block;\n    white-space: nowrap; }\n  \n  [data-scroll-direction=\"horizontal\"] [data-scroll-section] {\n    display: inline-block;\n    vertical-align: top;\n    white-space: nowrap;\n    height: 100%; }\n  \n  .c-scrollbar {\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 11px;\n    height: 100%;\n    transform-origin: center right;\n    transition: transform 0.3s, opacity 0.3s;\n    opacity: 0; }\n    .c-scrollbar:hover {\n      transform: scaleX(1.45); }\n    .c-scrollbar:hover, .has-scroll-scrolling .c-scrollbar, .has-scroll-dragging .c-scrollbar {\n      opacity: 1; }\n    [data-scroll-direction=\"horizontal\"] .c-scrollbar {\n      width: 100%;\n      height: 10px;\n      top: auto;\n      bottom: 0;\n      transform: scaleY(1); }\n      [data-scroll-direction=\"horizontal\"] .c-scrollbar:hover {\n        transform: scaleY(1.3); }\n  \n  .c-scrollbar_thumb {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: black;\n    opacity: 0.5;\n    width: 7px;\n    border-radius: 10px;\n    margin: 2px;\n    cursor: -webkit-grab;\n    cursor: grab; }\n    .has-scroll-dragging .c-scrollbar_thumb {\n      cursor: -webkit-grabbing;\n      cursor: grabbing; }\n    [data-scroll-direction=\"horizontal\"] .c-scrollbar_thumb {\n      right: auto;\n      bottom: 0; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
